<ng-select
  [items]="shapes"
  [clearable]="false"
  bindLabel="title"
  bindValue="id"
  [formControl]="tracingShape"
  placeholder=""
></ng-select>
